/*
 * @Description:
 * @Author: zhaoshuai
 * @Date: 2023-07-04 14:23:07
 * @LastEditTime: 2024-05-21 16:52:26
 * @LastEditors: zhaoshuai
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import {
	Button,
	Popover,
	Dialog,
	Message,
	Radio,
	RadioGroup,
	Loading,
	Input,
	Upload,
	Checkbox,
	Select,
	Option,
	DatePicker,
	Cascader,
	Link,
	MessageBox
} from 'element-ui';
import App from './App';
import router from './router';
// import switchRoute from './util/index'
import '@/assets/style/reset.css';
import { ProvOrDev } from './util/const';
import store from './store';
Vue.use(Loading.directive);
Vue.use(Button)
	.use(Popover)
	.use(Dialog)
	.use(Radio)
	.use(RadioGroup)
	.use(Input)
	.use(Upload)
	.use(Checkbox)
	.use(Select)
	.use(Option)
	.use(DatePicker)
	.use(Cascader)
	.use(Link);
Vue.prototype.$message = Message;
Vue.prototype.$MessageBox = MessageBox;
Vue.prototype.$baseUrl = ProvOrDev.apiUrl;
Vue.prototype.$returnUrl = ProvOrDev.returnUrl;
// Vue.prototype.switchRoute = switchRoute
// router.beforeEach((to, from, next) => {
//   var getFlag = localStorage.getItem('sceondUser')
//   if(to.path !== '/login'){
//     if(getFlag){
//       next()
//     }else{
//       next({
//         path: '/login'
//       })
//     }
//   }else{
//     next()
//   }
// })

new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js